import React from 'react';

function Healthcare() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			data-name="Layer 2"
			viewBox="0 0 25 29"
		>
			<path
				style={{
					fill: 'none',
					strokeLinejoin: 'round',
					strokeWidth: '2px',
				}}
				d="M26.77 15l.46-5.48a1.39 1.39 0 011.38-1.28A1.4 1.4 0 0130 9.67v8.24a.91.91 0 01-.28.67l-4.18 4.5a2 2 0 00-.54 1.37V26h-5v-6.24a1.93 1.93 0 01.55-1.34l3.78-3.79a1.4 1.4 0 012 0 1.4 1.4 0 010 2l-3 3M10.23 15l-.46-5.45a1.39 1.39 0 00-1.38-1.28A1.4 1.4 0 007 9.67v8.24a.91.91 0 00.28.67l4.18 4.5a2 2 0 01.54 1.37V26h5v-6.24a1.93 1.93 0 00-.55-1.34l-3.78-3.79a1.4 1.4 0 00-2 0 1.4 1.4 0 000 2l3 3M24 8.25A3.18 3.18 0 0020.89 5a3.07 3.07 0 00-2.39 1.17A3.07 3.07 0 0016.11 5 3.18 3.18 0 0013 8.25a3.32 3.32 0 001 2.36L18.5 15l4.5-4.39a3.32 3.32 0 001-2.36z"
				className="cls-1"
				transform="translate(-6 -4)"
			></path>
			<path d="M5 28L20 28" className="cls-1"></path>
		</svg>
	);
}

export default Healthcare;
